import * as React from 'react';

import type { LegalClient } from '@/api/legal-client';
import { HttpLegalClient } from '@/api/legal-client.http';

// =============================================================================
// legal-client-context.tsx — Injection du LegalClient (DI seam).
// =============================================================================
// Permet de substituer le client (double déterministe en test, impl HTTP réelle
// plus tard) sans toucher l'UI. Par défaut (Phase 2, D2a-MUT) : l'impl HTTP réelle ;
// le stub reste injectable via le provider en test. Instance partagée (sans état interne).

const defaultLegalClient: LegalClient = new HttpLegalClient();

const LegalClientContext = React.createContext<LegalClient>(defaultLegalClient);

export interface LegalClientProviderProps {
  client?: LegalClient | undefined;
  children: React.ReactNode;
}

export function LegalClientProvider({
  client = defaultLegalClient,
  children,
}: LegalClientProviderProps): React.JSX.Element {
  return (
    <LegalClientContext.Provider value={client}>
      {children}
    </LegalClientContext.Provider>
  );
}

export function useLegalClient(): LegalClient {
  return React.useContext(LegalClientContext);
}
